
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/crm/whatsapp",
      function () {
        return require("private-next-pages/integrations/crm/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/crm/whatsapp"])
      });
    }
  